import {Injectable} from '@angular/core';

/**
 * Translations for customer statuses.
 */
@Injectable()
export class CustomerStatusTranslationsService {
  public i18nActiveStatus: any = $localize`:@@general.status.active:Active`;
  public i18nLockedStatus: any = $localize`:@@general.status.locked:Locked`;
  public i18nDeparted: string = $localize`:@@general.status.departed:Departed`;
  public i18nSuspicionOfFraud: string = $localize`:@@general.status.suspicionOfFraud:Suspicion of fraud`;
  public i18nEncashment: string = $localize`:@@general.status.encashment:Encashment`;
  public i18nBlacklist: string = $localize`:@@general.status.blacklist:Blacklist`;
  public i18nStadiumBan: string = $localize`:@@general.status.stadiumBan:Stadium ban`;
  public i18nOtherReason: string = $localize`:@@general.status.otherReason:Other reason`;
  public i18nCustomerRequest: string = $localize`:@@general.status.customerRequest:Customer request`;
  public i18nUnknown: string = $localize`:@@general.status.unknown:Unknown`;
  public i18nChargeBack: string = $localize`:@@general.status.chargeBack:Charge back`;
  public i18nDirectDebitRecall: string = $localize`:@@general.status.directDebitRecall:Direct debit recall`;
  public i18nNoLockingReason: string = $localize`:@@general.status.noLockingReason:No locking reason`;
  constructor() { }
}
